import React, { useState } from "react";
import PropTypes from "prop-types";
import { ArrowDownIcon } from "../../../../../components/Icons/ArrowDownIcon";

function CheckboxLabel(props) {
  const { title, options, value, name, onChange, isLastest , isFilterDropdown } = props;
  const [show, $show] = useState(true);
  const onChangeCheckbox = (e, val) => {
    console.log("onChangeCheckbox->val", val);
    const data = value;
    if (data.includes(val) == false) {
      data.push(val);
    } else {
      data.splice(data.indexOf(val), 1);
    }
    onChange(data);
  };

  return (
    <div
      className={
        "pt-[32px] pb-7 px-0" + 
        (isLastest ? "" : " border-b border-solid border-black/[.15]")
      }
    >
      <div
        className="flex items-center justify-between text-lg font-bold text-black cursor-pointer"
        onClick={() => $show(!show)}
      >
        <span>{title}</span>
        {show && <ArrowDownIcon className="rotate-180 w-[12px] h-[12px]" />}
        {!show && <ArrowDownIcon className="w-[12px] h-[12px]" />}
      </div>
      <div
        className={
          "flex items-center justify-start flex-wrap gap-[14px] mt-[30px]" +
          (show ? "" : " hidden")
        }
      >
        {options.map((item, index) => {
          return (
            <label
              key={index}
              className={
                "h-[50px] min-w-[50px] text-base text-black text-center cursor-pointer rounded-[15px] p-[1px]" +
                (value?.includes(item.value) ? " bg-aia-red" : "")
              }
            >
              <span className={`block text-base text-black bg-white w-full h-full py-3 px-2.5 rounded-[13px] ${isFilterDropdown ? 'text-sm' : 'text-base'}`}>
                {item.title}
              </span>
              <input
                type="checkbox"
                name={name}
                value={item.value}
                onChange={($event) => onChangeCheckbox($event, item.value)}
                className="hidden"
              />
            </label>
          );
        })}
      </div>
    </div>
  );
}

CheckboxLabel.propTypes = {
  title: PropTypes.string,
  options: PropTypes.array,
  name: PropTypes.string,
  value: PropTypes.array,
  onChange: PropTypes.func,
  isLastest: PropTypes.bool,
};

export default CheckboxLabel;
